var _excluded = ["query", "headers", "body", "responseMappers", "errorMappers", "mode", "host", "path"],
  _excluded2 = ["query", "headers", "body", "mode", "host", "path"];
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import _classPrivateFieldGet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldGet";
import _classPrivateFieldSet from "@babel/runtime-corejs3/helpers/esm/classPrivateFieldSet";
function _classPrivateFieldInitSpec(obj, privateMap, value) {
  _checkPrivateRedeclaration(obj, privateMap);
  privateMap.set(obj, value);
}
function _checkPrivateRedeclaration(obj, privateCollection) {
  if (privateCollection.has(obj)) {
    throw new TypeError("Cannot initialize the same private elements twice on an object");
  }
}
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _URL from "@babel/runtime-corejs3/core-js/url";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$entries from "@babel/runtime-corejs3/core-js/object/entries";
import _JSON$stringify from "@babel/runtime-corejs3/core-js/json/stringify";
import _globalThis from "@babel/runtime-corejs3/core-js/global-this";
import _WeakMap from "@babel/runtime-corejs3/core-js/weak-map";
import deepExtend from "deep-extend";
import identity from "lodash/identity";
var withHelpfulMissingBodyError = function withHelpfulMissingBodyError(obj) {
  if (!Object.prototype.hasOwnProperty.call(obj, 'body')) {
    _Object$defineProperty(obj, 'body', {
      enumerable: false,
      get: function get() {
        throw new Error("Body of response is not automatically made available. You must either call \n  `const body = await result.response.json()` or `const body = await error.response.json()`\n\nor call #readJsonBody or #readJsonErrorBody() on the request builder\n");
      }
    });
  }
  return obj;
};
var withHelpfulMissingResponseError = function withHelpfulMissingResponseError(obj) {
  if (!Object.prototype.hasOwnProperty.call(obj, 'response') && !Object.prototype.hasOwnProperty.call(obj, 'body')) {
    _Object$defineProperty(obj, 'body', {
      enumerable: false,
      get: function get() {
        throw new Error("error.body is not available because no request was made. Check the network logs and console for more info");
      }
    });
  }
  return withHelpfulMissingBodyError(obj);
};
var errorResponseHandler = function errorResponseHandler(result) {
  var response = result.response;
  if (!response.ok) {
    var error = new Error(response.statusText);
    error.response = response;
    throw error;
  }
  return result;
};

/** a request builder based on fetch, useful in service workers  */
var _requestProperties = /*#__PURE__*/new _WeakMap();
var _responseMappers = /*#__PURE__*/new _WeakMap();
var _errorMappers = /*#__PURE__*/new _WeakMap();
var _mapResponse = /*#__PURE__*/new _WeakMap();
var _mapError = /*#__PURE__*/new _WeakMap();
var _extendCopy = /*#__PURE__*/new _WeakMap();
var FetchRequestBuilder = /*#__PURE__*/function () {
  function FetchRequestBuilder() {
    var _this = this;
    _classCallCheck(this, FetchRequestBuilder);
    _classPrivateFieldInitSpec(this, _requestProperties, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _responseMappers, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _errorMappers, {
      writable: true,
      value: void 0
    });
    _classPrivateFieldInitSpec(this, _mapResponse, {
      writable: true,
      value: function value(response) {
        var _context;
        return withHelpfulMissingBodyError(_reduceInstanceProperty(_context = _classPrivateFieldGet(_this, _responseMappers)).call(_context, /*#__PURE__*/function () {
          var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(last, mapper) {
            return _regeneratorRuntime().wrap(function _callee$(_context5) {
              while (1) switch (_context5.prev = _context5.next) {
                case 0:
                  _context5.t0 = withHelpfulMissingBodyError;
                  _context5.t1 = mapper;
                  _context5.next = 4;
                  return last;
                case 4:
                  _context5.t2 = _context5.sent;
                  _context5.t3 = (0, _context5.t1)(_context5.t2);
                  return _context5.abrupt("return", (0, _context5.t0)(_context5.t3));
                case 7:
                case "end":
                  return _context5.stop();
              }
            }, _callee);
          }));
          return function (_x, _x2) {
            return _ref4.apply(this, arguments);
          };
        }(), response));
      }
    });
    _classPrivateFieldInitSpec(this, _mapError, {
      writable: true,
      value: function () {
        var _value = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(error) {
          var _context2;
          return _regeneratorRuntime().wrap(function _callee3$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                _context7.t0 = withHelpfulMissingResponseError;
                _context7.next = 3;
                return _reduceInstanceProperty(_context2 = _classPrivateFieldGet(_this, _errorMappers)).call(_context2, /*#__PURE__*/function () {
                  var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(last, mapper) {
                    return _regeneratorRuntime().wrap(function _callee2$(_context6) {
                      while (1) switch (_context6.prev = _context6.next) {
                        case 0:
                          _context6.t0 = withHelpfulMissingResponseError;
                          _context6.t1 = mapper;
                          _context6.next = 4;
                          return last;
                        case 4:
                          _context6.t2 = _context6.sent;
                          _context6.t3 = (0, _context6.t1)(_context6.t2);
                          return _context6.abrupt("return", (0, _context6.t0)(_context6.t3));
                        case 7:
                        case "end":
                          return _context6.stop();
                      }
                    }, _callee2);
                  }));
                  return function (_x4, _x5) {
                    return _ref5.apply(this, arguments);
                  };
                }(), error);
              case 3:
                _context7.t1 = _context7.sent;
                throw (0, _context7.t0)(_context7.t1);
              case 5:
              case "end":
                return _context7.stop();
            }
          }, _callee3);
        }));
        function value(_x3) {
          return _value.apply(this, arguments);
        }
        return value;
      }()
    });
    _classPrivateFieldInitSpec(this, _extendCopy, {
      writable: true,
      value: function value(_ref) {
        var queryB = _ref.query,
          headersB = _ref.headers,
          bodyB = _ref.body,
          _ref$responseMappers = _ref.responseMappers,
          responseMappersB = _ref$responseMappers === void 0 ? [] : _ref$responseMappers,
          _ref$errorMappers = _ref.errorMappers,
          errorMappersB = _ref$errorMappers === void 0 ? [] : _ref$errorMappers,
          modeB = _ref.mode,
          hostB = _ref.host,
          _ref$path = _ref.path,
          pathB = _ref$path === void 0 ? [] : _ref$path,
          restB = _objectWithoutProperties(_ref, _excluded);
        var copy = new FetchRequestBuilder();
        var _classPrivateFieldGet2 = _classPrivateFieldGet(_this, _requestProperties),
          queryA = _classPrivateFieldGet2.query,
          headersA = _classPrivateFieldGet2.headers,
          bodyA = _classPrivateFieldGet2.body,
          modeA = _classPrivateFieldGet2.mode,
          hostA = _classPrivateFieldGet2.host,
          pathA = _classPrivateFieldGet2.path,
          restA = _objectWithoutProperties(_classPrivateFieldGet2, _excluded2);
        var responseMappersA = _classPrivateFieldGet(_this, _responseMappers);
        var errorMappersA = _classPrivateFieldGet(_this, _errorMappers);
        _classPrivateFieldSet(copy, _responseMappers, [].concat(_toConsumableArray(responseMappersA), _toConsumableArray(responseMappersB)));
        _classPrivateFieldSet(copy, _errorMappers, [].concat(_toConsumableArray(errorMappersA), _toConsumableArray(errorMappersB)));
        _classPrivateFieldSet(copy, _requestProperties, _objectSpread(_objectSpread(_objectSpread({}, restA), restB), {}, {
          mode: modeB || modeA,
          query: _objectSpread(_objectSpread({}, queryA), queryB),
          headers: _objectSpread(_objectSpread({}, headersA), headersB),
          body: bodyA || bodyB ? _objectSpread(_objectSpread({}, bodyA), bodyB) : null,
          host: hostB || hostA,
          path: [].concat(_toConsumableArray(pathA), _toConsumableArray(pathB))
        }));
        return copy;
      }
    });
    _classPrivateFieldSet(this, _responseMappers, []);
    _classPrivateFieldSet(this, _errorMappers, []);
    _classPrivateFieldSet(this, _requestProperties, {
      url: null,
      method: null,
      credentials: null,
      mode: null,
      query: {},
      body: null,
      headers: {},
      host: null,
      path: []
    });
  }
  _createClass(FetchRequestBuilder, [{
    key: "host",
    value: function host(_host) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        host: _host
      });
    }
  }, {
    key: "path",
    value: function path() {
      for (var _len = arguments.length, pathSegments = new Array(_len), _key = 0; _key < _len; _key++) {
        pathSegments[_key] = arguments[_key];
      }
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        path: _mapInstanceProperty(pathSegments).call(pathSegments, function (segment) {
          return segment.replace(/^\/+/, '').replace(/\/+$/, '').replace(/\/{2,}/, '/');
        })
      });
    }
  }, {
    key: "get",
    value: function get(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'GET'
      });
    }
  }, {
    key: "head",
    value: function head(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'HEAD'
      });
    }
  }, {
    key: "post",
    value: function post(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'POST'
      });
    }
  }, {
    key: "patch",
    value: function patch(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'PATCH'
      });
    }
  }, {
    key: "put",
    value: function put(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'PUT'
      });
    }
  }, {
    key: "del",
    value: function del(url) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        url: url,
        method: 'DELETE'
      });
    }
  }, {
    key: "query",
    value: function query(_query) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        query: _query
      });
    }
  }, {
    key: "set",
    value: function set(headerKey, headerValue) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        headers: _defineProperty({}, headerKey, headerValue)
      });
    }
  }, {
    key: "send",
    value: function send(body) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        body: body
      });
    }
  }, {
    key: "withCredentials",
    value: function withCredentials() {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        credentials: 'include'
      });
    }
  }, {
    key: "mode",
    value: function mode(_mode) {
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        mode: _mode
      });
    }
  }, {
    key: "mapResponse",
    value: function mapResponse() {
      for (var _len2 = arguments.length, responseMappers = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        responseMappers[_key2] = arguments[_key2];
      }
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        responseMappers: responseMappers
      });
    }
  }, {
    key: "mapError",
    value: function mapError() {
      for (var _len3 = arguments.length, errorMappers = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
        errorMappers[_key3] = arguments[_key3];
      }
      return _classPrivateFieldGet(this, _extendCopy).call(this, {
        errorMappers: errorMappers
      });
    }
  }, {
    key: "readJsonErrorBody",
    value: function readJsonErrorBody() {
      return this.mapError( /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4(err) {
          var newError;
          return _regeneratorRuntime().wrap(function _callee4$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                newError = new Error(err.message);
                newError.stack = err.stack;
                if (!err.response) {
                  _context8.next = 14;
                  break;
                }
                newError.response = err.response;
                _context8.prev = 4;
                _context8.next = 7;
                return err.response.json();
              case 7:
                newError.body = _context8.sent;
                _context8.next = 14;
                break;
              case 10:
                _context8.prev = 10;
                _context8.t0 = _context8["catch"](4);
                newError.body = null;
                newError.message += "\n\nAdditionally. This happened while trying to parse response: ".concat(_context8.t0.message);
              case 14:
                return _context8.abrupt("return", newError);
              case 15:
              case "end":
                return _context8.stop();
            }
          }, _callee4, null, [[4, 10]]);
        }));
        return function (_x6) {
          return _ref6.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "readJsonBody",
    value: function readJsonBody() {
      return this.mapResponse( /*#__PURE__*/function () {
        var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5(_ref2) {
          var response, body;
          return _regeneratorRuntime().wrap(function _callee5$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                response = _ref2.response;
                if (!(response.status === 204)) {
                  _context9.next = 3;
                  break;
                }
                return _context9.abrupt("return", {
                  response: response,
                  body: null
                });
              case 3:
                _context9.next = 5;
                return response.json();
              case 5:
                body = _context9.sent;
                return _context9.abrupt("return", {
                  response: response,
                  body: body
                });
              case 7:
              case "end":
                return _context9.stop();
            }
          }, _callee5);
        }));
        return function (_x7) {
          return _ref7.apply(this, arguments);
        };
      }()).readJsonErrorBody();
    }
  }, {
    key: "then",
    value: function then(resolveHandler, rejectHandler) {
      var _context3, _context4;
      var _classPrivateFieldGet3 = _classPrivateFieldGet(this, _requestProperties),
        urlString = _classPrivateFieldGet3.url,
        method = _classPrivateFieldGet3.method,
        body = _classPrivateFieldGet3.body,
        headers = _classPrivateFieldGet3.headers,
        credentials = _classPrivateFieldGet3.credentials,
        query = _classPrivateFieldGet3.query,
        mode = _classPrivateFieldGet3.mode,
        host = _classPrivateFieldGet3.host,
        path = _classPrivateFieldGet3.path;
      var fullUrl = _filterInstanceProperty(_context3 = [].concat(_toConsumableArray(path), [urlString])).call(_context3, identity).join('/');
      var url = new _URL(fullUrl, host === null ? undefined : host);
      _forEachInstanceProperty(_context4 = _Object$entries(query)).call(_context4, function (_ref3) {
        var _ref8 = _slicedToArray(_ref3, 2),
          key = _ref8[0],
          value = _ref8[1];
        url.searchParams.append(key, value);
      });
      var requestInit = {
        method: method,
        headers: headers
      };
      if (method !== 'HEAD' && method !== 'GET' && body !== null) {
        /* Only supports json body */
        if (!headers['Content-Type']) {
          /* eslint-disable-next-line no-console */
          console.warn('Body of request was set without a content type. Builder assumes that the body should be serialized as JSON, however you should still include a `Content-Type`');
        }
        requestInit.body = _JSON$stringify(body);
      }
      if (mode) requestInit.mode = mode;
      if (credentials) requestInit.credentials = credentials;
      return _globalThis.fetch(url, requestInit)
      // Wrap response to have parity with error handling API where response is in nested key
      .then(function (response) {
        return {
          response: response
        };
      }).then(errorResponseHandler).then(_classPrivateFieldGet(this, _mapResponse))["catch"](_classPrivateFieldGet(this, _mapError)).then(resolveHandler, rejectHandler);
    }
  }, {
    key: "catch",
    value: function _catch(rejectHandler) {
      return this.then(null, rejectHandler);
    }
  }, {
    key: "toJSON",
    value: function toJSON() {
      return deepExtend({}, _classPrivateFieldGet(this, _requestProperties));
    }
  }]);
  return FetchRequestBuilder;
}();
export { FetchRequestBuilder as default };
export var request = new FetchRequestBuilder();